var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3332 2.01177V10C15.3332 11.1015 14.4347 12 13.3332 12H2.6665C1.56498 12 0.666504 11.1015 0.666504 10V2C0.666504 0.898477 1.56498 0 2.6665 0H13.3332C14.4294 0 15.3245 0.889803 15.3331 1.98403C15.3333 1.99328 15.3333 2.00253 15.3332 2.01177ZM2.07091 1.7026C2.18116 1.4846 2.40788 1.33333 2.6665 1.33333H13.3332C13.5918 1.33333 13.8186 1.48463 13.9288 1.70266L7.99989 5.85289L2.07091 1.7026ZM1.99984 3.28039V10C1.99984 10.3651 2.30136 10.6667 2.6665 10.6667H13.3332C13.6983 10.6667 13.9998 10.3651 13.9998 10V3.28047L8.3822 7.21282C8.15266 7.3735 7.84713 7.3735 7.61759 7.21282L1.99984 3.28039Z",
    fill: "#636F7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a90e2896d47b70070d15af925cd5f5f1.svg";
export { ForwardRef as ReactComponent };